import { c as _c } from "react/compiler-runtime";
import { RoundupDriverGroupEnum } from '@cc-shopping/contracts/cross-site/marketplace/enums';
import { InfoTooltip } from '@cc-shopping/ui/composites/InfoTooltip';
import { Box, Grid, type GridProps, Typography } from '@mui/material';
import DOMPurify from 'isomorphic-dompurify';
import type { DriverType } from '../types';
import { DriverValueTooltip } from './DriverValueTooltip';
export const Driver = t0 => {
  const $ = _c(48);
  const {
    driver,
    driverGroup,
    itemProps,
    segmentActionSection
  } = t0;
  let t1;
  if ($[0] !== driver.valueTooltip) {
    t1 = driver.valueTooltip ? DOMPurify.sanitize(driver.valueTooltip) : driver.valueTooltip;
    $[0] = driver.valueTooltip;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const sanitizedTooltip = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [RoundupDriverGroupEnum.Rewards, RoundupDriverGroupEnum.Subprime];
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const isRewardsOrSubprimeRU = t2.includes(driverGroup);
  let t3;
  if ($[3] !== sanitizedTooltip) {
    t3 = sanitizedTooltip && <span dangerouslySetInnerHTML={{
      __html: sanitizedTooltip
    }} />;
    $[3] = sanitizedTooltip;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const valueTooltip = t3;
  let t4;
  if ($[5] !== driver.label) {
    t4 = driver.label.replace(/\s/g, "").toLocaleLowerCase();
    $[5] = driver.label;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const driverKey = t4;
  let t5;
  if ($[7] !== itemProps) {
    t5 = itemProps || {};
    $[7] = itemProps;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let itemPropsRest;
  let sx;
  if ($[9] !== t5) {
    ({
      sx,
      ...itemPropsRest
    } = t5);
    $[9] = t5;
    $[10] = itemPropsRest;
    $[11] = sx;
  } else {
    itemPropsRest = $[10];
    sx = $[11];
  }
  let t6;
  if ($[12] !== sx) {
    t6 = {
      pt: 2,
      display: "flex",
      flexDirection: "column",
      ...sx
    };
    $[12] = sx;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      display: "flex",
      alignItems: "center",
      flexWrap: "wrap",
      position: "relative",
      width: "fit-content"
    };
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      color: "neutral.darker",
      mb: 1
    };
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== driver.label) {
    t9 = <Typography data-testid="product-card-driver-label" variant="bodySmall" sx={t8}>{driver.label}</Typography>;
    $[16] = driver.label;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  const t10 = `${driver.label} information`;
  let t11;
  if ($[18] !== driver.labelTooltip || $[19] !== driver.labelTooltipMaxWidth || $[20] !== t10) {
    t11 = <InfoTooltip ariaLabel={t10} text={driver.labelTooltip} maxWidth={driver.labelTooltipMaxWidth} />;
    $[18] = driver.labelTooltip;
    $[19] = driver.labelTooltipMaxWidth;
    $[20] = t10;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11 || $[23] !== t9) {
    t12 = <Box sx={t7}>{t9}{t11}</Box>;
    $[22] = t11;
    $[23] = t9;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      display: "flex",
      alignItems: "center",
      flexWrap: "wrap",
      position: "relative",
      width: "100%"
    };
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      color: "#141414",
      pr: 1,
      fontSize: {
        xs: "15px",
        md: "16px"
      },
      lineHeight: {
        xs: "140% !important",
        md: "150%"
      },
      wordBreak: "break-word"
    };
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== driver.value) {
    t15 = <Typography data-testid="product-card-driver-value" variant="textBold" sx={t14}>{driver.value}</Typography>;
    $[27] = driver.value;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  const t16 = `More information about ${driver.label}`;
  let t17;
  if ($[29] !== isRewardsOrSubprimeRU) {
    t17 = isRewardsOrSubprimeRU && {
      minHeight: 0,
      minWidth: 0,
      containerStyles: {
        height: "22px"
      },
      triggerIconHeight: 18,
      triggerIconWidth: 18
    };
    $[29] = isRewardsOrSubprimeRU;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] !== driverKey || $[32] !== segmentActionSection || $[33] !== t16 || $[34] !== t17 || $[35] !== valueTooltip) {
    t18 = <DriverValueTooltip driverKey={driverKey} segmentActionSection={segmentActionSection} ariaLabel={t16} text={valueTooltip} {...t17} />;
    $[31] = driverKey;
    $[32] = segmentActionSection;
    $[33] = t16;
    $[34] = t17;
    $[35] = valueTooltip;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] !== t15 || $[38] !== t18) {
    t19 = <Box sx={t13}>{t15}{t18}</Box>;
    $[37] = t15;
    $[38] = t18;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  let t20;
  if ($[40] !== driver.description) {
    t20 = driver.description && <Typography variant="textSmall" sx={{
      color: "grey.500",
      textTransform: "capitalize"
    }}>{driver.description}</Typography>;
    $[40] = driver.description;
    $[41] = t20;
  } else {
    t20 = $[41];
  }
  let t21;
  if ($[42] !== itemPropsRest || $[43] !== t12 || $[44] !== t19 || $[45] !== t20 || $[46] !== t6) {
    t21 = <Grid sx={t6} {...itemPropsRest}>{t12}{t19}{t20}</Grid>;
    $[42] = itemPropsRest;
    $[43] = t12;
    $[44] = t19;
    $[45] = t20;
    $[46] = t6;
    $[47] = t21;
  } else {
    t21 = $[47];
  }
  return t21;
};